import { z } from "zod";
import { localStore } from "../../../lib/store";

export const TWO_WEEKS_IN_MS = 1000 * 60 * 60 * 24 * 14;

export const RoomInviteCodeDataSchema = z.object({
  roomInviteCode: z.string(),
  roomForceProfession: z.string().nullable().default(null),
  roomForceSpecialties: z.array(z.string()).default([]),
  roomUtmSource: z.string().nullable().default(null),
  roomUtmMedium: z.string().nullable().default(null),
  roomUtmContent: z.string().nullable().default(null),
  roomDiscoveryChannel: z
    .enum(["public app", "shared article", "qr code", "related room"])
    .nullable()
    .default(null),
  roomPlaylistId: z.string().nullable().default(null),
  timestamp: z.number(),
});

export type RoomInviteCodeData = z.infer<typeof RoomInviteCodeDataSchema>;

export const roomInviteCodeStore = localStore<RoomInviteCodeData | null>(
  "roomInviteCodeData",
  null,
  RoomInviteCodeDataSchema.nullable()
);

export function setRoomInviteCodeData(
  data: Omit<RoomInviteCodeData, "timestamp">
): void {
  roomInviteCodeStore.set({ ...data, timestamp: Date.now() });
}

export function clearRoomInviteCodeData(): void {
  roomInviteCodeStore.set(null);
}

export function hasPendingRoomInvite(): boolean {
  const data = roomInviteCodeStore.get();
  if (data === null) return false;
  return Date.now() <= data.timestamp + TWO_WEEKS_IN_MS;
}
